<template>
  <Layout class="layout">
    <Header>
      <Menu mode="horizontal" theme="dark" active-name="1">
        <div class="layout-logo"></div>
        <div class="layout-nav">
          <MenuItem name="1" to="/">
            <Icon type="ios-home" />
            首页
          </MenuItem>
          <Submenu name="2">
            <template #title>
              <Icon type="ios-copy" />
              信息
            </template>
            <MenuItem name="2-1" to="/info-article">文章</MenuItem>
            <MenuItem name="2-2" to="/info-mp">公众号</MenuItem>
          </Submenu>
          <Submenu name="3">
            <template #title>
              <Icon type="ios-list-box" />
              任务
            </template>
            <MenuItem name="3-1" to="/task-index">列表任务</MenuItem>
            <MenuItem name="3-2" to="/task-content">正文任务</MenuItem>
          </Submenu>
          <Submenu name="4">
            <template #title>
              <Icon type="ios-contact" />
              账号
            </template>
            <MenuItem name="4-1" to="/worker-wx">微信号</MenuItem>
            <MenuItem name="4-2" to="/worker-mp">平台号</MenuItem>
          </Submenu>
          <Submenu name="5">
            <template #title>
              <Icon type="ios-construct" />
              其他
            </template>
            <MenuItem name="5-1" to="/docs">接口</MenuItem>
            <MenuItem name="5-2" to="/logs">日志</MenuItem>
            <MenuItem name="5-3" to="/debug">调试</MenuItem>
          </Submenu>
        </div>
      </Menu>
    </Header>

    <Content :style="{padding: '0 50px'}">
      <Card>
        <div style="min-height: 200px;">
          <Layout>
            <router-view/>
          </Layout>
        </div>
      </Card>
    </Content>
    <Footer class="layout-footer-center">2011-2025 &copy; mlkj</Footer>
  </Layout>
</template>

<style scoped>
.layout{
  position: relative;
  overflow: hidden;
  min-width: 1500px;
}
.layout-logo{
  width: 100px;
  height: 30px;
  border-radius: 3px;
  float: left;
  position: relative;
  top: 15px;
  left: 20px;
}
.layout-nav{
  width: 580px;
  margin: 0 auto;
  margin-right: 20px;
}
.layout-footer-center{
  text-align: center;
}
.layout-topMiddleBottom .ivu-menu-light{
  background:none;
  color: #fff
}
</style>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

}

</style>
<script>
import {Card, Content, Icon, Layout, MenuItem, Submenu} from "view-ui-plus";
import { state } from "@/socket";

export default {
  name: 'app',
  components: {Submenu, Card, Content, Icon, MenuItem, Layout},
  data() {
    return {
      'theme': 'primary'
    }
  },
  computed: {
    connected() {
      return state.connected;
    }
  }
}
</script>
